import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useQuery } from 'react-apollo';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './Partners.css';
import getPartnerShops from '../../getPartnerShops.graphql';
import messages from '../../../../locale/messages';

function Partners() {
  useStyles(s);

  const { data } = useQuery(getPartnerShops, { ssr: true });
  const shops =
    (data && data.getPartnerShops && data.getPartnerShops.shops) || [];

  // Nothing to show until we have real partner logos.
  if (!shops.length) return null;

  // Duplicate the list so the marquee can loop seamlessly.
  const track = [...shops, ...shops];
  // Longer lists scroll longer so speed stays consistent.
  const duration = Math.max(20, shops.length * 3);

  return (
    <section className={s.partners}>
      <div className={s.inner}>
        <p className={s.eyebrow}>
          <FormattedMessage {...messages.homePartnersEyebrow} />
        </p>
        <h2 className={s.title}>
          <FormattedMessage {...messages.homePartnersTitle} />
        </h2>
      </div>

      <div className={s.marquee}>
        <div className={s.track} style={{ animationDuration: `${duration}s` }}>
          {track.map((shop, i) => (
            <div key={`${shop.id}-${i}`} className={s.logo}>
              <img src={shop.picture} alt={shop.shopName} title={shop.shopName} />
              <span className={s.name}>{shop.shopName}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Partners;
